import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema, isEmpty } from "../../../Schema";
import { yesNoBooleanOptions } from "../../common";

export const shouldAssisted: FieldSchema = {
  grid: {
    displayed: true,
    order: 76,
    ignoredForSearch: true,
  },
  name: "shouldAssisted",
  data: {
    variant: DataVariants.ENUM,
    options: yesNoBooleanOptions,
    assignedValue: {
      getter: ({ shouldAssisted, isBookable }) =>
        !isBookable ? EMPTY_VALUE : isEmpty(shouldAssisted) ? false : shouldAssisted,
      fields: ["isBookable"],
    },
  },
  dataTransform: {
    // A non-bookable equipment has no booking behaviour to record, so the stored value
    // is cleared rather than left behind to contradict isBookable.
    toDb: {
      getter: ({ isBookable, shouldAssisted }) =>
        isBookable === false ? EMPTY_VALUE : shouldAssisted,
      fields: ["isBookable", "shouldAssisted"],
    },
  },
  display: {
    displayed: true,
  },
  validation: {
    required: {
      getter: ({ isBookable }) => isBookable === true,
      fields: ["isBookable"],
    },
  },
  form: {
    label: "Assisted booking",
    type: InputTypes.SELECT,
    disabled: {
      getter: ({ isBookable }) => isBookable !== true,
      fields: ["isBookable"],
    },
    helperText: "Ask user declare the presence of hazardous materials",
  },
};
